import { providers } from "../../../../assets/data/providers";
import React, { useRef, useEffect, useState } from "react";
import style from "./Brands.module.css";

const Brands = () => {
  const speedRef = useRef(0.5); // velocidad constante

  //Subdividir arrays

  const chunkArray = (arr, parts) => {
    const result = [];
    const size = Math.ceil(arr.length / parts); // tamaño aproximado de cada parte
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const [first, second, third] = chunkArray(providers, 3);

  // 2) Offsets independientes (1 y 3 a la izquierda, 2 a la derecha)
  const [offset1, setOffset1] = useState(0);
  const [offset2, setOffset2] = useState(0); // este va en sentido opuesto
  const [offset3, setOffset3] = useState(0);

  // ancho aproximado de cada carril (ajustá 100 si tus logos ocupan otro ancho)
  const W1 = first.length * 100;
  const W2 = second.length * 100;
  const W3 = third.length * 100;

  useEffect(() => {
    let frame;
    const animate = () => {
      const v = speedRef.current;

      // carril 1: izquierda
      setOffset1(prev => {
        const next = prev + v;
        return next >= W1 ? 0 : next;
      });

      // carril 2: derecha (cuenta hacia atrás)
      setOffset2(prev => {
        const next = prev - v;
        return next < 0 ? next + W2 : next; // wrap sin valores negativos
      });

      // carril 3: izquierda
      setOffset3(prev => {
        const next = prev + v;
        return next >= W3 ? 0 : next;
      });

      frame = requestAnimationFrame(animate);
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [W1, W2, W3]);

  return (
    <div className={style.brands}>
      <h2>Marcas que <span>comercializamos</span></h2>
      <div className={style.allMarquees}>
        <div className={style.marqueeContainer}>
          <div
            className={style.marqueeInner}
            style={{ transform: `translateX(-${offset1}px)` }}
          >
            {[...first, ...first, ...first, ...first, ...first, ...first].map((p, i) => (
              <div key={i} className={style.logoItem}>
                  <a href={p.link} target="_blank" rel="noopener noreferrer">
                      <img src={p.logo} alt={p.name} />
                  </a>
              </div>
            ))}
          </div>
        </div>
        <div className={style.marqueeContainer}>
          <div
            className={style.marqueeInner}
            style={{ transform: `translateX(-${offset2}px)` }}
          >
            {[...second, ...second, ...second, ...second, ...second, ...second].reverse().map((p, i) => (
              <div key={i} className={style.logoItem}>
                  <a href={p.link} target="_blank" rel="noopener noreferrer">
                      <img src={p.logo} alt={p.name} />
                  </a>
              </div>
            ))}
          </div>
        </div>
        <div className={style.marqueeContainer}>
          <div
            className={style.marqueeInner}
            style={{ transform: `translateX(-${offset3}px)` }}
          >
            {[...third, ...third, ...third, ...third, ...third, ...third].map((p, i) => (
              <div key={i} className={style.logoItem}>
                  <a href={p.link} target="_blank" rel="noopener noreferrer">
                      <img src={p.logo} alt={p.name} />
                  </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <p>- envíos sin cargo -</p>
    </div>
  );
};

export default Brands;
